import React, { useEffect, useState } from "react"
import Modal from "../../../../components/Modal"
import { TAgetRunpodWorkerPosts } from "../../../../services/runpodAPI"

interface RunpodPostsInterface {
  isOpen?: boolean
  onClose?: () => void
  post_ids: string[]
  gpuIndex: number
}

const RunpodPosts: React.FC<RunpodPostsInterface> = ({ isOpen, onClose, post_ids, gpuIndex }) => {
  const [postData, setPostData] = useState<any[]>([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    if (isOpen && post_ids.length > 0) {
      fetchPosts()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen, post_ids])

  const fetchPosts = async () => {
    try {
      setIsLoading(true)
      const res = await TAgetRunpodWorkerPosts(post_ids)
      setPostData(res.data)
    } finally {
      setIsLoading(false)
    }
  }

  if (!isOpen) {
    return null
  }

  return (
    <>
      <Modal
        classname="fixed inset-0 bg-black/50 flex justify-center items-center z-50"
        classname2="bg-white w-full md:w-1/2 h-5/6 rounded-xl p-6 overflow-auto"
        onClick={onClose}
      >
        <h2 className="text-xl font-bold mb-4">{`GPU - ${gpuIndex} Posts`}</h2>

        {isLoading ? (
          <div className="flex justify-center py-10">
            <div className="animate-spin h-10 w-10 border-t-4 border-blue-600 rounded-full"></div>
          </div>
        ) : (
          <div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-2 mb-2 px-1 font-semibold text-gray-700">
              <div>Post ID</div>
              <div>Açıklama</div>
              <div>Ses Çevirisi</div>
            </div>

            {postData.map((item, idx) => (
              <div
                className="grid grid-cols-1 md:grid-cols-3 gap-2 border rounded-xl p-4 bg-white shadow-sm cursor-pointer hover:shadow-md transition"
                key={idx}
              >
                {/* LEFT - VIDEO OR IMAGE */}
                <div className="flex flex-col items-center justify-center">
                  {item.video_url &&
                  !/^https:\/\/scontent-.*\.cdninstagram\.com\//.test(item.video_url) ? (
                    <video
                      src={item.video_url}
                      controls
                      className="w-full h-40 object-cover rounded bg-gray-200"
                    />
                  ) : (
                    <div className="w-full h-40 bg-gray-200 rounded flex items-center justify-center">
                      <img
                        src={item.thumbnail || item.media_url}
                        className="w-full h-full object-cover rounded"
                      />
                    </div>
                  )}
                  <span className="text-xs lg:text-sm">{item._id}</span>
                </div>

                {/* MIDDLE - IMAGE DESCRIPTION */}
                {item.image_description_v4 && (
                  <div className="flex flex-col bg-gray-50 p-3 rounded border max-h-40 overflow-y-auto">
                    {Array.isArray(item.image_description_v4) ? (
                      <ul className="text-xs space-y-1">
                        {item.image_description_v4.map((desc: any, i: number) => {
                          if (typeof desc === "string" || typeof desc === "number") {
                            return <li key={i}>{desc}</li>
                          }
                          if (typeof desc === "object" && desc !== null) {
                            const time = desc.time ?? ""
                            const text = desc.text ?? "<boş>"
                            return (
                              <li key={i}>
                                <span className="font-medium">[{time}s]</span> {text}
                              </li>
                            )
                          }
                          return null
                        })}
                      </ul>
                    ) : (
                      <span className="text-xs">{item.image_description_v4 || "-"}</span>
                    )}
                  </div>
                )}

                {/* RIGHT - VOICE TO TEXT */}
                {item.voice_to_text_sequences && (
                  <div className="flex flex-col bg-gray-50 p-3 rounded border max-h-40 overflow-y-auto">
                    {Array.isArray(item.voice_to_text_sequences) &&
                    item.voice_to_text_sequences.length > 0 ? (
                      <ul className="text-xs space-y-1">
                        {item.voice_to_text_sequences.map((seq: any, i: number) => {
                          const start = seq.start ?? seq.time ?? ""
                          const end = seq.end ?? ""
                          const text = seq.text ?? "<boş>"
                          return (
                            <li key={i}>
                              <span className="font-medium">
                                [{start}s → {end}s]
                              </span>{" "}
                              {text}
                            </li>
                          )
                        })}
                      </ul>
                    ) : (
                      <span className="text-xs">-</span>
                    )}
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </Modal>
    </>
  )
}

export default RunpodPosts
